import { type Components, type Theme } from "@mui/material/styles";

export const inputBase: Components<Theme>["MuiInputBase"] = {
  defaultProps: {
    "data-1p-ignore": "true",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.whiteStates.main,
    }),
    input: ({ theme }) => ({
      backgroundColor: theme.palette.whiteStates.main,
      "::placeholder": {
        color: theme.palette.text.disabled,
        opacity: 1,
      },
    }),
  },
};
